// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
export const defaultProps = {
    prefixCls: "pm-search",
    placeholder: "",
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    disabled: false,
};
